module.exports = __webpack_public_path__ + "img/control_de_calidad2_4-3_682.9ef7fa74.webp";